module.exports = __webpack_public_path__ + "static/media/13.f9f67ade.jpg";